<style scoped lang="scss">
  h4{
    color: #014492;
    font-size: 16px;
    margin:20px 0 10px;
  }
  .img-info{
    display: flex;
    justify-content: space-around;
  }
  .img-box{
    display: flex;
    align-items: center;
    height:228px;
    background: #E8F5F5;
  }
  p{
    font-size: 16px;
    line-height: 2;
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/常规分子项目/banner5.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>特定基因检测</h1>-->
<!--          <h2 class="mt10">Specific Genetic Testing</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <p>针对某些特定基因的扩增和测序检测条件的优化及大批量样本检测。</p>
      <div class="c-title">服务流程<small>Service Process</small></div>
      <div class="tc"><img src="@/assets/images/specific_1.png"></div>
      <div class="rec mt30">应用举例：如：EGFR基因</div>
      <h4>名词解释：</h4>
      <p>EGFR（epidermal growth factor receptor）即表皮生长因子受体，正常情况下包埋在细胞表面的细胞膜中，是一种对肿瘤细胞的繁殖、 生长、修复和存活等起重要作用的膜蛋白。 EGFR蛋白的过表达和EGFR酪氨酸激酶的基因突变导致肿瘤的生长和进展。</p>
      <el-row :gutter="40" type="flex" align="middle" class="mt30">
        <el-col :span="12">
          <h4>病变机制：</h4>
          <p>表皮生长因子受体(EGFR) 结构图A，配体EGF活化图B，通过二聚化
            使胞内酪氨酸激酶结构域被激活图C。</p>
          <h4>检测结果的指导意义：</h4>
          <p>酪氨酸激酶（TK）抑制剂能竞争性地与ATP结合位点结合从而阻断
            配体激活表皮生长因子受体（EGFR）；EGFR 基因酪氨酸激酶区域
            中存在多种突变，这些突变主要集中在外显子18-21上，其中以18号
            外显子的点突变、19号外显子内缺失以及21号外显子的L858R最为
            常见，这些突变能够很好预测易瑞莎和特罗凯的治疗效果，可以为医
            生合理指导用药提供依据。</p>
        </el-col>
        <el-col :span="12">
          <!-- <img src="@/assets/images/specific_2.png" class="img-fluid"> -->
          <!-- <ul class="img-info">
            <li>图A</li>
            <li>图B</li>
            <li>图C</li>
          </ul> -->
        </el-col>
      </el-row>
      <el-row :gutter="40" type="flex" align="middle" class="mt30">
        <el-col :span="12">
          <h4>基因突变位点：</h4>
          <p>EGFR基因位于：人第7号染色体短臂7p12 ~ 14区；</p>
          <p>长度:   192 kbp (碱基对)；</p>
          <p>组成：28个外显子，其中主要检测18、19、20、21四个外显子。</p>
        </el-col>
        <!-- <el-col :span="12"><img src="@/assets/images/specific_3.png" class="img-fluid"></el-col> -->
      </el-row>
      <el-row :gutter="40" type="flex" align="middle" class="mt30">
        <el-col :span="12">
          <h4>突变区域序列：</h4>
          <div class="img-box">
            <img src="@/assets/images/specific_4.png" class="img-fluid">
          </div>
        </el-col>
        <el-col :span="12">
          <h4>基因突变位点：</h4>
          <img src="@/assets/images/specific_5.png" class="img-fluid">
        </el-col>
      </el-row>
      <div class="c-title">送样要求<small>Sample Delivery Requirements</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img src="@/assets/images/snp_6.png" class="img-fluid">
        </el-col>
        <el-col :span="12">
          <div class="required">
            <p class="mb20">1、新鲜标本：50 mg以上的组织，液氮，干冰保存，运输；</p>
            <p class="mb20">2、酒精固定标本：手术台上取下的样品（体积大于5 x 5 x 5 mm），用
              75%的乙醇固定于容内，保证乙醇体积是标本的5倍；</p>
            <p class="mb20">3、石蜡包埋标本：提供6-8张组织切片（面积大于10 x 10 mm，厚度约为
              5-10 μm），肿瘤组织比例应不少于70%，坏死组织比例少于10%；</p>
            <p>4、前期固定液应为10%中性福尔马林，载玻片片盒保存、常温运输。如果
              组织太小，请酌情增加送检样品量。</p>
          </div>
        </el-col>
      </el-row>
      <div class="c-title">结果交付<small>Delivery Of Results</small></div>
      <p class="tc">交付测序峰图和突变统计表格</p>
      <div class="tc mt30"><img src="@/assets/images/specific_7.png"></div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/specific.vue